/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSales200ResponseAllOfData } from './GetSales200ResponseAllOfData';
import {
    GetSales200ResponseAllOfDataFromJSON,
    GetSales200ResponseAllOfDataFromJSONTyped,
    GetSales200ResponseAllOfDataToJSON,
} from './GetSales200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetSales200ResponseAllOf
 */
export interface GetSales200ResponseAllOf {
    /**
     * 
     * @type {GetSales200ResponseAllOfData}
     * @memberof GetSales200ResponseAllOf
     */
    data: GetSales200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetSales200ResponseAllOf interface.
 */
export function instanceOfGetSales200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetSales200ResponseAllOfFromJSON(json: any): GetSales200ResponseAllOf {
    return GetSales200ResponseAllOfFromJSONTyped(json, false);
}

export function GetSales200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSales200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetSales200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetSales200ResponseAllOfToJSON(value?: GetSales200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetSales200ResponseAllOfDataToJSON(value.data),
    };
}

